import { TFunction } from 'i18next';
import { ButtonColorTypes } from 'modules/admin-panel/pages/settings/models';

export const getButtonColorTypeList = (t: TFunction) =>
	Object.values(ButtonColorTypes).map((type: ButtonColorTypes) => {
		return { value: type, title: t(`emails.${type}_color`) };
	});
